import React from 'react'
import Expencesform from './newexpencesform'


function Newexpences(props) {
  const saveData = expdata => {
    const data = {
      ...expdata,
      id : Math.round(Math.random() * 100)
    }
    props.epxData(data)
  }
  return (
    <div>
      <Expencesform  saveData={saveData}/>
    </div>
  )
}

export default Newexpences
